module.exports = __webpack_public_path__ + "64f0b9c6b4668abebbc9de0bfc7ced1a.png";